import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';

const apiStates = [
  ...restApiStates(['sellers'], 'seller', true, false),
  ...restApiStates(['sellers', 'items'], 'sellersItem'),
  ...restApiStates(['sellers', 'mark-as-read'], 'sellersMarkAsRead'),
  ...restApiStates(['sellers', 'accept'], 'sellersAccept'),
];

const instantStates = [];
const storage = {};
const listValues = ['sellers', 'sellersItems'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
